// Lucide icon: star-half (https://lucide.dev/icons/star-half)
import { StarHalf } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconStarHalfSolid = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled $filled {...props}>
      <StarHalf strokeWidth={0} />
    </IconComponentStyled>
  )
}
